import React, { useEffect, useState } from "react"
import { Col, Container, Form, Modal, Row } from "react-bootstrap"

import * as yup from "yup"

import API from "@/common/API"
import { useFormik } from "formik"
import Settings from "@/common/Settings"
import { parsedUser } from "@/common/GetCurrentUser"
import FieldSelector from "@/components/core/FieldSelector"
import GeoPickerModal from "@/components/core/GeoPickerModal"

const AddEditPlace = props => {
  const [isLoading, setIsLoading] = useState(false)
  const user = parsedUser()
  const isOchoaOrg = String(user?.OrganizationId ?? "")
    .toLowerCase()
    .includes("ochoa")
  const validationSchema = yup.object({
    name: yup.string().required("required"),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
    image: yup.string().required(),
    categoryId: yup.string().required(),
    stageId: yup.string().required(),
    creditCode: isOchoaOrg
      ? yup
          .string()
          .nullable()
          .matches(/^[A-Z]{2}-\d{4,5}$/, "Formato: AA-1234 o AA-12345", {
            excludeEmptyString: true,
          })
      : yup.string().nullable(),
  })
  const handleSubmit = async (obj, event) => {
    try {
      console.log("values to submit", obj)
      obj.organizationId = user.OrganizationId
      obj.createdId = user.ID
      let objToBeSent = {
        id: obj.id,
        name: obj.name,
        latitude: obj.latitude,
        longitude: obj.longitude,
        image: obj.image,
        image2: obj.image2,
        note: obj.note,
        categoryId: obj.categoryId,
        stageId: obj.stageId,
        organizationId: obj.organizationId,
        createdId: obj.createdId,
        updatedId: obj.id ? user.ID : null,
        creditCode: obj.creditCode ?? null,
      }
      setIsLoading(true)
      let request = await API.postAction("place/AddEdit", objToBeSent)
      setIsLoading(false)

      console.log("response from adding", request)
      if (request.status === 200) {
        props.toggle(null, true)
      }
    } finally {
      setIsLoading(false)
    }
  }
  console.log(props.model)
  const formik = useFormik({
    validateOnBlur: false,
    validateOnChange: false,
    initialValues: props.model
      ? props.model
      : {
          latitude: null,
          longitude: null,
          id: null,
          name: "",
          image: null,
          image2: null,
          note: null,
          categoryId: null,
          stageId: null,
          creditCode: null,
        },
    validationSchema,
    onSubmit: handleSubmit,
  })
  const [categories, setCategories] = useState([])
  const [stages, setStages] = useState([])

  const [showGeoPicker, setShowGeoPicker] = useState(false)

  const GetLocation = () => {
    var geoSuccess = function (position) {
      // Do magic with location

      console.log("the position", position.coords)
      formik.setFieldValue("latitude", position.coords.latitude)
      formik.setFieldValue("longitude", position.coords.longitude)

      //Now we need to request the information from Google
    }
    var geoError = function (error) {
      switch (error.code) {
        case error.TIMEOUT:
          // The user didn't accept the callout
          // showNudgeBanner();
          break
      }
    }

    navigator.geolocation.getCurrentPosition(geoSuccess, geoError)
  }

  const requestCategories = async () => {
    let requestAPI = await API.getAction("category/List")
    if (requestAPI.data.status === "ok") {
      setCategories(requestAPI.data.response)
    }
  }
  const requestStages = async () => {
    let requestAPI = await API.getAction("stage/List")
    if (requestAPI.data.status === "ok") {
      setStages(requestAPI.data.response)
    }
  }

  const uploadImg = async (obj, field) => {
    let file = obj.target.files[0]
    console.log(file)
    // Ensure it's an image
    if (file.type.match(/image.*/)) {
      console.log("An image has been loaded")
      let bodyData = new FormData()
      bodyData.append("path", file)
      let request = await API.postAction(`File/Upload`, bodyData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      if (request) {
        formik.setFieldValue(field, request.data.response)
      }
    }
  }

  useEffect(() => {
    requestCategories()
    requestStages()
  }, [])

  const geoField = {
    name: "location",
    title: "Ubicación",
    htmlType: "geo",
    dbType: "string",
    required: false,
    containerClass: "col-12",
    latField: "latitude",
    lngField: "longitude",
    actionLabel: "Generar pin",
    onAction: () => GetLocation(),
    onOpenPicker: () => setShowGeoPicker(true),
  }

  const imageFieldPrimary = {
    name: "image",
    title: "Imagen Principal",
    htmlType: "image",
    dbType: "string",
    required: false,
    containerClass: "col-12",
    accept: "image/*",
    onFileUpload: obj => uploadImg(obj, "image"),
    previewBasePath: `${Settings.BasePath}/files/`,
    previewStyle: { width: "200px" },
  }

  const imageFieldSecondary = {
    name: "image2",
    title: "Imagen Secundaria (opcional)",
    htmlType: "image",
    dbType: "string",
    required: false,
    containerClass: "col-12",
    accept: "image/*",
    onFileUpload: obj => uploadImg(obj, "image2"),
    previewBasePath: `${Settings.BasePath}/files/`,
    previewStyle: { maxHeight: "200px" },
  }

  const fields = [
    {
      name: "creditCode",
      title: "Código de Crédito",
      htmlType: "creditCode",
      dbType: "string",
      containerClass: "col-12 col-md-6",
      placeholder: isOchoaOrg ? "AA-12345" : undefined,
      maxLength: isOchoaOrg ? 8 : undefined,
      pattern: isOchoaOrg ? "[A-Z]{2}-\\d{4,5}" : undefined,
      inputMode: isOchoaOrg ? "text" : undefined,
      enforceCreditCodeFormat: isOchoaOrg,
    },
    {
      name: "name",
      title: "Nombre",
      htmlType: "text",
      dbType: "string",
      required: true,
      containerClass: "col-12",
    },
    geoField,
    {
      name: "categoryId",
      title: "Categoria",
      htmlType: "select",
      dbType: "string",
      required: true,
      containerClass: "col-12 col-md-6",
      dataSourceLocal: categories,
      dataSourceValueField: "id",
      dataSourceTextField: "name",
    },
    {
      name: "stageId",
      title: "Etapa",
      htmlType: "select",
      dbType: "string",
      required: true,
      containerClass: "col-12 col-md-6",
      dataSourceLocal: stages,
      dataSourceValueField: "id",
      dataSourceTextField: "name",
    },

    {
      name: "note",
      title: "Nota",
      htmlType: "textarea",
      dbType: "string",
      containerClass: "col-12",
    },
    imageFieldPrimary,
    imageFieldSecondary,
  ]

  return (
    <>
      <GeoPickerModal
        show={showGeoPicker}
        onClose={() => setShowGeoPicker(false)}
        initialPosition={{
          lat: formik.values.latitude || 18.4718609,
          lng: formik.values.longitude || -69.8923187,
        }}
        onSelect={pos => {
          formik.setFieldValue("latitude", pos.lat)
          formik.setFieldValue("longitude", pos.lng)
        }}
      />
      <Modal
        show={props.show}
        onHide={props.toggle}
        size="md"
        className="modalRight"
      >
        <Modal.Header closeButton>
          <Row className="mx-0 w-100">
            <Col>
              <h5>Lugar</h5>
            </Col>
          </Row>
        </Modal.Header>

        <Form onSubmit={formik.handleSubmit}>
          <Modal.Body className="p-0" style={{ overflow: "auto" }}>
            <Container>
              <Row>
                {fields.map(field => (
                  <FieldSelector
                    key={field.name}
                    model={field}
                    updateField={formik.setFieldValue}
                    obj={formik.values}
                    value={formik.values[field.name]}
                    errors={formik.errors}
                  />
                ))}
              </Row>
            </Container>
          </Modal.Body>
        </Form>
        <Modal.Footer className="p-1">
          <button
            disabled={isLoading}
            className="btn btn-primary"
            onClick={() => {
              formik.submitForm()
            }}
          >
            Guardar
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddEditPlace
